export class TileBackground {
    url?: string;
    color?: string;
    title: string;
}